<template>
  <div>
    <!-- DRAWER -->
    <v-navigation-drawer
      id="core-drawer"
      v-model="Mdrawer"
      v-bind="Entorno.drawer"
    >

      <v-divider />

      <!-- MENU -->
      <AppMenu />
    </v-navigation-drawer>

    <!-- BAR -->
    <v-app-bar  v-bind="Entorno.bar">

      <v-app-bar-nav-icon @click.stop="Mdrawer = !Mdrawer"></v-app-bar-nav-icon>

      <v-toolbar-title>
          <div class="conflex">
            <div :class="Entorno.bar.titulo_class">
              {{ Entorno.bar.titulo }}
              <span :class="Entorno.bar.subtitulo_class"> {{Entorno.bar.subtitulo}}</span>
              <span :class="Entorno.bar.aplicacion_class"> {{Entorno.bar.aplicacion}}</span>
            </div>

            <v-spacer> </v-spacer>
            <div v-if="!$store.state.G.PRODUCTION" style="margin-left:50px;">ESTA VERSIÓN ES SÓLO PARA PRUEBAS</div>

          </div>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <div v-if="$store.state.login_estado">
        <v-btn
          color="blue-grey lighten-1"
          small
          title="Ayuda"
          class="mr-3"
          @click="ayuda(9)"
          >
          <v-icon class="mr-1"> mdi-help-circle</v-icon>
          Guía práctica
        </v-btn>

        <v-menu rounded offset-y class="mr-6">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="blue-grey lighten-1"
              small dark
              v-bind="attrs"
              v-on="on"
            >
            <v-icon> mdi-info-circle</v-icon>
              Ayudas
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in ayudas"
              :key="index"
              link
              @click="ayuda(index)"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

      </div>

      <v-spacer></v-spacer>


      <div  class="conflex" style="margin-left:auto;align-items:center">

        <div class="blue-grey--text text--lighten-2" style="margin:10px">
           {{ $store.state.login_estado? $store.state.G.USUARIO : '' }}
        </div>
        <v-btn
          color="blue-grey lighten-1"
          fab
          x-small
          :title="$store.state.login_estado? 'Cerrar Sesión' : 'Iniciar Sesión'"
          @click="logInOut">
            <v-icon> {{ $store.state.login_estado?"mdi-account-lock":"mdi-lock" }}</v-icon>
        </v-btn>

      </div>

    </v-app-bar>
  </div>
</template>

<script>
import plugs from "@/common/general_plugs";
const AppMenu = () => plugs.groute("AppMenu.vue", "comp");

export default {
  components: { AppMenu },

  data() {
    return {
      Entorno: this.$cfg.app,
      Mdrawer: true,

      guias: [
        { title: 'Guia Práctica', file: 'guia_funescom_apd_v2' }
      ],
      ayudas: [
        { title: 'Guia APDS Integración Decesos SI24', file: 'guia_apds_integracion_decesos_si24'},
        { title: 'Guia APDS Garantía de Tramitación de Documentos', file: 'guia_apds_garantia_tramitacion_documentos'},
        { title: 'Combos habilitados para APDS', file: 'combos_habilitados_apds'},
        { title: 'Información COS', file: 'info_cos'},
      ],
    };
  },


  methods: {
    logInOut() {
      if (this.$store.state.login_estado) this.logOut();
      this.logIn()
    },


    //
    async logOut() {
      let args = { tipo: "login", api: "login", accion: "logout" };
      await this.$store.dispatch("ajaxRequest", { args: args });

      this.$store.commit('logout');
      this.$router.push({ path: 'login' });
    },


    //
    logIn() {
      if (this.$router.options.routes.length) {
        if (this.$router.options.routes[this.$router.options.routes.length - 1].redirect=='/') return;
      }

      this.$router.push({ path: 'login' });
    },


    ayuda(tp=0) {console.log(this.$store.state);
      //window.open('https://funescom.com/ayuda/guia_funescom_apd_v2.pdf', "_blank");

      let url=this.$store.state.G.urladm;
      let file=(tp==9 ? this.guias[0].file : this.ayudas[tp].file );
      window.open(`${url}/ayuda/${file}.pdf`, "_blank");
    }

  }
};
</script>
